import { LoaderFunctionArgs } from 'react-router';
import { fetchNomenclatureCategory } from '../NomenclatureCategoriesPage/services';

export const nomenclatureCategoryLoader = async ({
  params,
}: LoaderFunctionArgs) => {
  const id = String(params.id);

  if (id === 'new') {
    return { data: null };
  }

  try {
    const data = await fetchNomenclatureCategory({ id });
    return { data };
  } catch (error) {
    return { data: null };
  }
};
